export const getZoomControlsVisible = (isMapPresentational: boolean, isZoomEnabledInPublicSettings: boolean | undefined) =>
  !isMapPresentational || !!isZoomEnabledInPublicSettings;
